import { useEffect } from 'react';
import useStore from '../Hooks/useStore';
import Modal from '../Modal';
import { Socket, io } from 'socket.io-client';

const Session = ({ children }) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    socket: { connect, disconnect, SOCKET },
    auth: { onConfirmLogout },
  } = setters;
  const confirmSessionModal = getModal('single.confirmSession');

  useEffect(() => {
    connect();
    onConfirmLogout();
    window.addEventListener('beforeunload', disconnect);
    return () => {
      window.removeEventListener('beforeunload', disconnect);
      disconnect();
      SOCKET.removeListener('logout');
      SOCKET.removeListener('confirm-logout');
    };
  }, []);

  return confirmSessionModal ? <Modal.ConfirmSession /> : children;
};

export default Session;
